import React, { useId } from 'react';

import { ReloadOutlined, WarningOutlined } from '@ant-design/icons';
import { Button, Typography } from 'antd';

import type { ExecutionsHistoryErrorCode } from '@src/models/interfaces/executionsHistoryDashboard.interface';
import { HISTORY_SECTION_ERROR_MESSAGE_IDS } from '@src/packages/dashboard/components/ReportSummary/historySectionErrorMessageIds';
import IntlMessages from '@src/util/IntlMessages';

import styles from './ReportEventErrorState.module.less';

interface Props {
  onRetry: () => void;
  errorCode?: ExecutionsHistoryErrorCode;
}

/** Calm, actionable failure state that keeps the report drawer context visible. */
const ReportEventErrorState: React.FC<Props> = ({ onRetry, errorCode }) => {
  const titleId = useId();
  const descriptionId = useId();
  const descriptionMessageId = errorCode && errorCode !== 'UNKNOWN'
    ? HISTORY_SECTION_ERROR_MESSAGE_IDS[errorCode]
    : 'dashboards.reportEventDrawer.error.description';

  return (
    <section
      aria-labelledby={titleId}
      aria-describedby={descriptionId}
      className={styles.errorState}
      role="alert"
    >
      <span aria-hidden="true" className={styles.icon}>
        <WarningOutlined />
      </span>
      <Typography.Title className={styles.title} id={titleId} level={5}>
        <IntlMessages id="dashboards.reportEventDrawer.error.title" />
      </Typography.Title>
      <Typography.Paragraph className={styles.description} id={descriptionId}>
        <IntlMessages id={descriptionMessageId} />
      </Typography.Paragraph>
      <Button icon={<ReloadOutlined aria-hidden="true" />} onClick={onRetry}>
        <IntlMessages id="dashboards.tasks.summary.section.retry" />
      </Button>
    </section>
  );
};

export default ReportEventErrorState;
